export const vTrim = {
  mounted(el) {
    const handleTrim = (input) => {
      const start = input.selectionStart
      const end = input.selectionEnd
      const trimmedValue = input.value.replace(/^\s+|\s+$/g, '')
      if (trimmedValue !== input.value) {
        input.value = trimmedValue
        input.setSelectionRange(
          start - (input.value.length - trimmedValue.length),
          end - (input.value.length - trimmedValue.length),
        )
        input.dispatchEvent(new Event('input'))
      }
    }

    const setupHandler = (input) => {
      const trimHandler = () => handleTrim(input)
      input.addEventListener('input', trimHandler)
      input._trimHandler = trimHandler
    }

    if (el.tagName.toLowerCase() === 'input') {
      setupHandler(el)
    } else {
      const input = el.querySelector('input')
      if (input) {
        setupHandler(input)
      }
    }
  },
  beforeUnmount(el) {
    if (el.tagName.toLowerCase() === 'input') {
      const input = el
      if (input && input._trimHandler) {
        input.removeEventListener('input', input._trimHandler)
        delete input._trimHandler
      }
    } else {
      const input = el.querySelector('input')
      if (input && input._trimHandler) {
        input.removeEventListener('input', input._trimHandler)
        delete input._trimHandler
      }
    }
  },
}
